module.exports = __webpack_public_path__ + "img/noimg.5ff375d6.png";